<article class="teaser-block">
    <div class="teaser-wrapper teaser-block-wrapper">
      <figure class="teaser-crop teaser-block-crop">
          <img [src]="teaserItem.Image ? teaserItem.Image.ImageUrl + '?w=375&h=290&mode=crop' : 'https://api.mvrdv.fstr.io/placeholders/Placeholder-Landscape.jpg'" [alt]="teaserItem.Title" />
      </figure>

      <div class="teaser-content teaser-block-content">
          <header class="teaser-header teaser-block-header">
              <h1 class="teaser-title teaser-block-title ">{{teaserItem.Title}}</h1>
              <strong class="teaser-subtitle teaser-block-subtitle">{{teaserItem.Subtitle}}</strong>
          </header>
          <div class="teaser-text teaser-block-text">
              <div [innerHTML]="teaserItem.Description"></div>
          </div>
      </div>

      <a [routerLink]="[teaserItem.DetailUrl]" [class.routingDisabled]="teaserItem.DisableRouting" class="teaser-link teaser-block-link">Meer over </a>
    </div>
</article>
